import React from 'react';
import { LoadingComponentProps } from 'react-loadable';
import { ConnectedProps, connect } from 'react-redux';

import { LoadingSection } from 'components/LoadingSection';
import { Modal } from 'modals/Modal';
import { setError } from 'store/main/ducks/error';
import { hideModal } from 'store/main/ducks/modal';

type Props = LoadingComponentProps & PropsFromRedux;

class LoadingModal extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.error && !prevProps.error) {
      // Show the error page if loading the modal bundle failed
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.setError(this.props.error, false);
    }
  }

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.pastDelay) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        <Modal onClose={this.props.hideModal}>
          <LoadingSection delay={0} />
        </Modal>
      );
    }

    return null;
  }
}

const connector = connect(null, {
  hideModal,
  setError,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

// eslint-disable-next-line import/no-default-export
export default connector(LoadingModal);
